import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a7b6b74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-title" }
const _hoisted_2 = { class: "wrapper-subtitle" }
const _hoisted_3 = { class: "wrapper-buttons" }
const _hoisted_4 = { class: "d-wrapper-title" }
const _hoisted_5 = { class: "d-wrapper-subtitle" }
const _hoisted_6 = { class: "d-wrapper-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_input = _resolveComponent("drive-input")!
  const _component_app_skeleton_folder = _resolveComponent("app-skeleton-folder")!
  const _component_drive_desktop_input = _resolveComponent("drive-desktop-input")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "popUp",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.mainStore.closeCreateFolderPopUp && _ctx.mainStore.closeCreateFolderPopUp(...args)))
      }, [
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
          class: "wrapper"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('app.create.folder.title')), 1)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$localize('app.create.folder.add.name')), 1)
          ]),
          _createVNode(_component_drive_input, {
            modelValue: _ctx.folderName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.folderName) = $event)),
            modelModifiers: { trim: true },
            title: _ctx.$localize('app.create.folder.input.title'),
            bold: "",
            onOnEnter: _ctx.createFolder,
            "disabled-enter": "",
            enterkeyhint: "done",
            error: _ctx.error,
            class: "error-margin"
          }, null, 8, ["modelValue", "title", "onOnEnter", "error"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              class: "btn btn-cancel",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mainStore.closeCreateFolderPopUp && _ctx.mainStore.closeCreateFolderPopUp(...args)))
            }, _toDisplayString(_ctx.$localize('app.create.folder.cancel.button')), 1),
            _createElementVNode("a", {
              class: _normalizeClass([{'disabled': _ctx.disabled}, "btn btn-create"]),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createFolder && _ctx.createFolder(...args)))
            }, _toDisplayString(_ctx.$localize('app.create.folder.create.button')), 3)
          ])
        ]),
        (_ctx.loader)
          ? (_openBlock(), _createBlock(_component_app_skeleton_folder, {
              key: 0,
              title: _ctx.folderName,
              grid: _ctx.driveStore.isGridPhotoView,
              hideSkeletons: ""
            }, null, 8, ["title", "grid"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "d-popUp",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.mainStore.closeCreateFolderPopUp && _ctx.mainStore.closeCreateFolderPopUp(...args)))
      }, [
        _createElementVNode("div", {
          onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
          class: "d-wrapper"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('app.create.folder.title')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$localize('app.create.folder.add.name')), 1)
          ]),
          _createVNode(_component_drive_desktop_input, {
            modelValue: _ctx.folderName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.folderName) = $event)),
            modelModifiers: { trim: true },
            title: _ctx.$localize('app.create.folder.input.title'),
            bold: "",
            onOnEnter: _ctx.createFolder,
            "disabled-enter": "",
            enterkeyhint: "done",
            error: _ctx.error,
            class: "error-margin"
          }, null, 8, ["modelValue", "title", "onOnEnter", "error"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              class: "btn btn-cancel",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.mainStore.closeCreateFolderPopUp && _ctx.mainStore.closeCreateFolderPopUp(...args)))
            }, _toDisplayString(_ctx.$localize('app.create.folder.cancel.button')), 1),
            _createElementVNode("a", {
              class: _normalizeClass([{'disabled': _ctx.disabled}, "btn btn-create"]),
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.createFolder && _ctx.createFolder(...args)))
            }, _toDisplayString(_ctx.$localize('app.create.folder.create.button')), 3)
          ])
        ]),
        (_ctx.loader)
          ? (_openBlock(), _createBlock(_component_app_skeleton_folder, {
              key: 0,
              title: _ctx.folderName,
              grid: _ctx.driveStore.isGridPhotoView,
              hideSkeletons: ""
            }, null, 8, ["title", "grid"]))
          : _createCommentVNode("", true)
      ]))
}